(() => {
  let started = false;
  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    const allowed = privacy?.analyticsProcessingAllowed?.() === true;
    // A fresh page is needed to stop an already running third-party recorder.
    if (started && !allowed) { window.location.reload(); return; }
    if (!allowed || started) return;
    started = true;
    window.hj = window.hj || function () { (window.hj.q = window.hj.q || []).push(arguments); };
    window._hjSettings = { hjid: 5224202, hjsv: 6 };
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.hotjar.com/c/hotjar-5224202.js?sv=6';
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) syncConsent(); });
  }
})();
